import { h } from "@stencil/core";
// import { defaultLayout, layout2, layoutRenders } from "./renders";
import { layout3, layoutRenders } from "./renders";
export class ChTestFlexibleLayout {
    constructor() {
        this.layout = layout3;
    }
    render() {
        return (h("ch-flexible-layout-render", { layout: this.layout, renders: layoutRenders }));
    }
    static get is() { return "ch-test-flexible-layout"; }
    static get originalStyleUrls() {
        return {
            "$": ["test-flexible-layout.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["test-flexible-layout.css"]
        };
    }
    static get properties() {
        return {
            "layout": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "FlexibleLayout",
                    "resolved": "Omit<LayoutSplitterDistribution, \"items\"> & { items: FlexibleLayoutItem[]; }",
                    "references": {
                        "FlexibleLayout": {
                            "location": "import",
                            "path": "../../flexible-layout/types",
                            "id": "src/components/flexible-layout/types.ts::FlexibleLayout"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the distribution of the items in the flexible layout."
                },
                "defaultValue": "layout3"
            }
        };
    }
}
//# sourceMappingURL=test-flexible-layout.js.map
